import StandardEvent from './StandardEvent';
export class SnapchatStandardEvents {
    pageView() {
        return new StandardEvent('PAGE_VIEW');
    }
    signUp() {
        return new StandardEvent('SIGN_UP');
    }
    purchase() {
        return new StandardEvent('PURCHASE');
    }
    save() {
        return new StandardEvent('SAVE');
    }
    startCheckout() {
        return new StandardEvent('START_CHECKOUT');
    }
    addCart() {
        return new StandardEvent('ADD_CART');
    }
    openApp() {
        return new StandardEvent('OPEN_APP');
    }
    viewContent() {
        return new StandardEvent('VIEW_CONTENT');
    }
    addBilling() {
        return new StandardEvent('ADD_BILLING');
    }
    search() {
        return new StandardEvent('SEARCH');
    }
    subscribe() {
        return new StandardEvent('SUBSCRIBE');
    }
    adClick() {
        return new StandardEvent('AD_CLICK');
    }
    adView() {
        return new StandardEvent('AD_VIEW');
    }
    completeTutorial() {
        return new StandardEvent('COMPLETE_TUTORIAL');
    }
    invite() {
        return new StandardEvent('INVITE');
    }
    login() {
        return new StandardEvent('LOGIN');
    }
    share() {
        return new StandardEvent('SHARE');
    }
    reserve() {
        return new StandardEvent('RESERVE');
    }
    achievementUnlocked() {
        return new StandardEvent('ACHIEVEMENT_UNLOCKED');
    }
    addToWishlist() {
        return new StandardEvent('ADD_TO_WISHLIST');
    }
    spentCredits() {
        return new StandardEvent('SPENT_CREDITS');
    }
    rate() {
        return new StandardEvent('RATE');
    }
    startTrial() {
        return new StandardEvent('START_TRIAL');
    }
    listView() {
        return new StandardEvent('LIST_VIEW');
    }
    custom1() {
        return new StandardEvent('CUSTOM_EVENT_1');
    }
    custom2() {
        return new StandardEvent('CUSTOM_EVENT_2');
    }
    custom3() {
        return new StandardEvent('CUSTOM_EVENT_3');
    }
    custom4() {
        return new StandardEvent('CUSTOM_EVENT_4');
    }
    custom5() {
        return new StandardEvent('CUSTOM_EVENT_5');
    }
}
//# sourceMappingURL=StandardEvents.js.map